import { call, takeEvery } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { resetTestState, setTestStatus } from "@store/tests/testSlice";
import { trackNotificationChoice } from "@store/ui/uiSlice";
import { trackEvent, trackPageView, NOTIFICATION_EVENTS } from "@utils/tracking/gtag";
import { NotificationEventType } from "@/types/notificationTypes";
import { getVirtualPageForTestStatus } from "@utils/tracking/testPhaseViews";
import { TestStatus } from "types/tests";

let lastVirtualPage: string | null = null;

function* handleTestStatusChanged(action: PayloadAction<{ status: TestStatus }>) {
  if (typeof window === "undefined" || !window.location.pathname.startsWith("/new-test")) {
    return;
  }
  const virtualPage = getVirtualPageForTestStatus(action.payload.status);
  if (!virtualPage || virtualPage === lastVirtualPage) {
    return;
  }
  lastVirtualPage = virtualPage;
  yield call(trackPageView, virtualPage);
}

function handleResetTestState() {
  lastVirtualPage = null;
}

function* handleNotificationChoice(
  action: PayloadAction<{
    type: NotificationEventType;
    notificationId: string;
    actionId?: string;
  }>,
) {
  const { type, notificationId, actionId } = action.payload;
  yield call(trackEvent, NOTIFICATION_EVENTS[type], {
    notification_id: notificationId,
    ...(actionId ? { action_id: actionId } : {}),
  });
}

export default function* trackingSagas() {
  lastVirtualPage = null;
  yield takeEvery(setTestStatus.type, handleTestStatusChanged);
  yield takeEvery(resetTestState.type, handleResetTestState);
  yield takeEvery(trackNotificationChoice.type, handleNotificationChoice);
}
